import { axiosSwagger } from "@/axios";


export const state = {
    publicSearch: {
        loading: false,
        data: [],
        total: 0,
    },
    publicFileType: {
        data: []
    },
    publicFileTag: {
        data: []
    },
}


export const getters = {
}


export const mutations = {
    // CATEGORY
    loading: (state, loading) => {
        state.publicSearch.loading = loading;
    },
    setData: (state, data) => {
        state.publicSearch.data = data;
    },
    setTotal: (state, total) => {
        state.publicSearch.total = total;
    },
    setPublicFileTypes: (state, data) => {
        state.publicFileType.data = modifyFileTypeData( data );
    },
    setPublicFileTags: (state, data) => {
        state.publicFileTag.data = modifyFileTagData( data );
    }
}


export const actions = {
    async readPublicFilesByCategoryId({ commit }, id) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/FilePosting/Public/Category/${id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async readPublicFilesByCampusId({ commit }, id) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/FilePosting/Public/Campus/${id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async readPublicFiles({ commit }) {
        commit("loading", true);
    
        return await axiosSwagger
        .get(`/api/FilePosting/Public`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            
            commit("setPublicFileTypes", response.data);
            commit("setPublicFileTags", response.data);

            commit("loading", false);
        
            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
}



// modify data
const modifyFileTypeData = (arrayData) => {
    if(arrayData?.length ?? false){
        const _fileTypes = [];

        arrayData.forEach(e => {

            e.fileManager.fileManagerFiles.forEach(ee => {

                let fileTypeExt = ee.fileType.split('/')[1];
                
                if( !_fileTypes.includes(fileTypeExt) ){
                    _fileTypes.push(fileTypeExt);
                }

            });

        });
        
        return _fileTypes;
    }
  
    return [];
};


const modifyFileTagData = (arrayData) => {
    if(arrayData?.length ?? false){
        const _fileTags = [];

        arrayData.forEach(e => {

            e.fileManager.fileTags.forEach(ee => {
                
                if( !_fileTags.includes(ee.tag) ){
                    _fileTags.push(ee.tag);
                }

            });

        });
        
        return _fileTags;
    }
  
    return [];
};